// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCmP2tfBRNsnljistGJeqn2lXIVmGHaq_c",
  authDomain: "decentrawill.firebaseapp.com",
  projectId: "decentrawill",
  storageBucket: "decentrawill.appspot.com",
  messagingSenderId: "790585367692",
  appId: "1:790585367692:web:542f2003fb511082f16fa9",
  measurementId: "G-30K85G178Q",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const functions = getFunctions(app);
const firestore = getFirestore(app);
// Use emulators if in development
console.log("window.location.hostname", window.location.hostname);
if (window.location.hostname === "127.0.0.1") {
  console.log("Connecting to emulators...");
  connectAuthEmulator(auth, "http://127.0.0.1:9099");
  console.log("Connected to Auth emulator on port 9099");
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  console.log("Connected to Functions emulator on port 5001");
  connectFirestoreEmulator(firestore, "127.0.0.1", 4001);
  console.log("Connected to Firestore emulator on port 4001");
}
export { app, auth, functions, firestore };
